import { createDirectus, readItem, readItems, rest } from '@directus/sdk'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const directusUrl = config.public.directusUrl as string

  if (!directusUrl) {
    throw new Error('NUXT_PUBLIC_DIRECTUS_URL is not defined')
  }

  const directus = createDirectus(directusUrl).with(rest())

  return {
    provide: { directus, readItem, readItems },
  }
})
